import { Realtime } from '@doxyme/realtime';
import {
  getFrontendConfigLoader,
  getGrowthBookConfigLoader,
} from '@doxyme/config';

const realtimeBackendUrl = getFrontendConfigLoader().get(
  'REALTIME_BACKEND_URL',
) as string;
const getVendorLogLevel = () =>
  getGrowthBookConfigLoader().getOptional('realtime_vendor_log_level') as
    | number
    | undefined;

export const realtimeInstance = new Realtime(
  realtimeBackendUrl,
  getVendorLogLevel,
);
